// addresses modules
import axios from 'axios';
import {
  RECIPE_URL,
  RECIPE_PAGINATE_URL,
  RECIPE_COMMENT_URL,
  RECIPE_OPTION_URL
} from '../../api/url.js';

// initial state
const state = {
  recipes: [],
  fourRecipes: [],
  selectRecipeId: '',
  recipesPaginate: '',
  recipesCount: '',
}

// actions
const actions = {
  // fetch all recipes
  async fetchRecipes(context) {
    const config = {
      method: 'GET',
      url: `${RECIPE_PAGINATE_URL}limit=10&page=1`,
    };
    await axios(config) 
    .then((response) => {
      context.commit('fetchRecipes', response.data);
    }, (err) => {
      console.log("fetchRecipes error:", err);
    })
  },
  
  // Filter recipes
  async filterRecipes(context, [page, dishType, difficulty]) {
    let config = {
      method: 'GET',
      url: `${RECIPE_PAGINATE_URL}limit=10&page=${page}`,
    };
    if (dishType !== '' && difficulty !== '') {
      config = {
        method: 'GET',
        url: `${RECIPE_PAGINATE_URL}limit=10&page=${page}&dish_type=${dishType}&difficulty=${difficulty}`,
      };
    } else if (dishType === '' && difficulty !== '') {
      config = {
        method: 'GET',
        url: `${RECIPE_PAGINATE_URL}limit=10&page=${page}&difficulty=${difficulty}`,
      };
    } else if (dishType !== '' && difficulty === '') {
      config = {
        method: 'GET',
        url: `${RECIPE_PAGINATE_URL}limit=10&page=${page}&dish_type=${dishType}`,
      };
    }
    
    await axios(config) 
    .then((response) => {
      context.commit('fetchRecipesPaginate', response.data);
    }, (err) => {
      console.log("fetchRecipes error:", err);
    })
  },
  // fetch top 4 recipe for home page
  async fetch4Recipes(context) {
    const config = {
      method: 'GET',
      url: `${RECIPE_PAGINATE_URL}limit=4&page=1`,
    };
    await axios(config)
    .then((response) => {
      context.commit('fetch4Recipes', response.data);
    }, (err) => {
      console.log("fetchRecipes error:", err);
    })
  },
  // fetch recipe
  fetchRecipeDetail: (context, recipeId) => axios({
    method: 'GET',
    url: `${RECIPE_URL}${recipeId}`, 
  }),
  
  // post recipe comment
  async postRecipeComment(context, [form, recipeId]) {
    const config = {
      method: 'POST',
      data: form,
      url: `${RECIPE_COMMENT_URL}${recipeId}`,
    };
    await axios(config) 
    .then((response) => {
      console.log('postcomment: ', response);
    }, (err) => {
      console.log("postcomment error:", err);
    })
  }
};

// mutations
const mutations = {
  fetchRecipes(state, payload) {
    state.recipes = payload.record;
    state.recipesPaginate = payload.pages;
    state.recipesCount = payload.count;
  },
  fetch4Recipes(state, payload) {
    state.fourRecipes = payload.record;
  },
  fetchRecipesPaginate(state, payload) {
    state.recipes = payload.record;
    state.recipesPaginate = payload.pages;
    state.recipesCount = payload.count;
  },
  updateRecipeId(state, number) {
    state.selectRecipeId = number;
  },
}

export default {
  strict: true,
  namespaced: true,
  state,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/store/modules/recipe.js